var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8571 9.14286H9.14286V14.8571C9.14286 15.4857 8.62857 16 8 16C7.37143 16 6.85714 15.4857 6.85714 14.8571V9.14286H1.14286C0.514286 9.14286 0 8.62857 0 8C0 7.37143 0.514286 6.85714 1.14286 6.85714H6.85714V1.14286C6.85714 0.514286 7.37143 0 8 0C8.62857 0 9.14286 0.514286 9.14286 1.14286V6.85714H14.8571C15.4857 6.85714 16 7.37143 16 8C16 8.62857 15.4857 9.14286 14.8571 9.14286Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.b3f80db1b41f9e8b48b0873f5d98cd44.svg";
export { ForwardRef as ReactComponent };